import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import MessagesFilters from '../components/message-filters/MessagesFilters';
import Messages from '../components/messages/Messages';
import { useProject } from '../../../../context/ProjectContext';
import { changeSavedTableSettings } from '../../../../redux/activ8/activ8MessagesReducer';

function SavedTab({ bindNextAction }) {
  const { id: projectId } = useParams();
  const { actions } = useProject();
  const dispatch = useDispatch();

  const content = useSelector((state) => state.activ8Messages.savedMessagesContent);
  const isLoading = useSelector((state) => state.activ8Messages.isMessagesLoading);
  const tableSettings = useSelector((state) => state.activ8Messages.savedTableSettings);

  const handleClearAll = () => {
    actions('deleteSavedMessages');
  };

  const handleChangeSearch = (newSearch) => {
    dispatch(changeSavedTableSettings({ searchQuery: newSearch, page: 0 }));
  };

  useEffect(() => {
    actions('searchMessages', { id: projectId });
  }, [projectId, tableSettings.searchQuery]);

  return (
    <>
      <MessagesFilters
        onClearAll={handleClearAll}
        query={tableSettings.searchQuery}
        onChangeSearch={handleChangeSearch}
      />
      <Messages bindNextAction={bindNextAction} content={content} isLoading={isLoading} isShowSaveButton={false} />
    </>
  );
}

export default SavedTab;
